// Price formatting function
export const formatPrice = (price: number): string => {
  return `₦${price?.toLocaleString()}`;
};

// Discount percentage formatting
export const formatDiscount = (percentage: number): string => {
  return `${percentage}% off`;
};
